import React, { Fragment, useEffect, useMemo, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { toast } from "react-hot-toast";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";

import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import { useUserBySalesMutation, useSudamaPointTransferMutation } from "../../../features/tenant/Orders/ordersApi";
import { set } from "lodash";
import TenantSlugs from "../../../utils/TenantSlug";

const OrderSummary = () => {
  const navigate = useNavigate();
  const [allUsers, setAllUsers] = useState([]);
  const [usersCount, setUsersCount] = useState(0);
  const [fetchAppUserByUserType, { data: appUsersData, isLoading: appUsersDataLoading, error: appUsersError }] =
    useUserBySalesMutation();
  useEffect(() => {
    if (appUsersDataLoading) {
      toast.dismiss();
      toast.loading("loading ...", {
        id: "delete loading ",
      });
    }
    if (appUsersData) {
      toast.dismiss();
      setAllUsers(appUsersData.body.users)
      setUsersCount(appUsersData.body.user_count)

    }

  }, [appUsersDataLoading, appUsersData]);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const currentDate = new Date().toISOString().split("T")[0];
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
  const [appUsers, setAppUsers] = useState(appUserTypes);
  const [userTypesArray, setUserTypesArray] = useState({
    name: "All",
    id: null,
  });
  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [remarks, setRemarks] = useState();
  const initialRequest = {
    user_type_id: userTypeId,
    limit: 10,
    offset: 0,
    mobile: "",
  };
  const [request, setRequest] = useState(initialRequest);

  const [pointTransferModal, setPointTransferModal] = useState(false);
  const [ptStartDate, setPtStartDate] = useState("");
  const [ptEndDate, setPtEndDate] = useState("");
  const [ptIsLifetime, setPtIsLifetime] = useState(false);

  const [
    sudamaPointTransfer,
    {
      data: pointTransferData,
      isLoading: pointTransferLoading,
      error: pointTransferError,
    },
  ] = useSudamaPointTransferMutation();

  useEffect(() => {
    if (pointTransferData) {
      toast.dismiss("point-transfer-loading");
      toast.success(pointTransferData?.message || "Point Transfer Successful", {
        id: "point-transfer-success",
      });

      const data = pointTransferData?.body || []; 

      if (data.length) {
        const headers = Object.keys(data[0]);

        const csvRows = [
          headers.join(","), 
          ...data.map((row) =>
            headers.map((field) => `"${row[field] ?? ""}"`).join(",")
          ),
        ];

        const csvString = csvRows.join("\n");

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "point-transfer.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        toast.error("No data found for the selected dates");
      }

      setPointTransferModal(false);
    }

    if (pointTransferError) {
      toast.dismiss("point-transfer-loading");
      toast.error(pointTransferError?.data?.message || "Point Transfer Failed", {
        id: "point-transfer-error",
      });
    }
  }, [pointTransferData, pointTransferError]);

  const handlePointTransfer = () => {
    if (!ptIsLifetime && (!ptStartDate || !ptEndDate)) {
      toast.error("Please select both start date and end date, or check Lifetime");
      return;
    }
    toast.loading("Fetching Point Transfer...", { id: "point-transfer-loading" });

    let bodyPayload = {};
    if (!ptIsLifetime) {
      bodyPayload = {
        start_date: ptStartDate,
        end_date: ptEndDate,
      };
    }

    sudamaPointTransfer({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: bodyPayload,
    });
  };

  useMemo(() => {
    for (let index = 0; index < appUsers.length; index++) {
      const element = appUsers[index];
      if (
        element?.user_type?.toLocaleLowerCase() ===
        userTypesArray?.name?.toLocaleLowerCase()
      ) {
        setUserTypeId(element.user_type_id);
        setRequest((prevRequest) => ({
          ...prevRequest,
          user_type_id: +element.user_type_id,
        }));
        break;
      }
    }
  }, [userTypesArray]);

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
  };


  const fetchAppUserByUserTypeFunction = (request) => {
    // request["limit"] = limit;
    // request["offset"] = offset;
    fetchAppUserByUserType({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: { ...request, limit, offset },
    });
  };

  useEffect(() => {
    fetchAppUserByUserTypeFunction(initialRequest)
  }, [request, limit, offset]);

  const clearFilters = () => {
    setUserTypeId(null)
    setUserTypesArray({
      name: "All",
      id: null,
    });
    setRequest({ ...initialRequest, user_type_id: null });
    fetchAppUserByUserTypeFunction({ ...initialRequest, user_type_id: null });
  };


  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "User Id",
      cell: (row) => <div>{row.user_id}</div>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Name",
      cell: (row) => <div>{row.name}</div>,
      sortable: true,
      width: "200px",
    },
    {
      name: "Email",
      cell: (row) => row.email,
      sortable: true,
    },
    {
      name: "Mobile",
      cell: (row) => row.mobile,
      sortable: true,
    },
    {
      name: "UserType",
      cell: (row) => row.user_type,
      sortable: true,
    },
    ...TenantSlugs.century == JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ? [
      {
        name: "Manager Name",
        cell: (row) => row.l1_manager_name,
        sortable: true,
        width: "150px",
      }, {
        name: "Manager Emp id",
        cell: (row) => row.l1_manager_employee_id,
        sortable: true,
        width: "150px",
      },
    ] : [],
    {
      name: "Received Points",
      cell: (row) => (
        <p
          onClick={() => navigate("recieve/" + row.id)}
          style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
        >
          View Received Points
        </p>
      ),
      width: "200px",
      sortable: true,
    },
    {
      name: "Transfer Points",
      cell: (row) => (
        <p
          onClick={() => navigate("transfer/" + row.id)}
          style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
        >
          View Transfer Points
        </p>
      ),
      width: "200px",
      sortable: true,
    }
  ];



  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Order Summary
            <LinksComponent />
          </div>

          <div className="p-3 ">

            <div className=" w-full bg-white shadow rounded-lg">
              <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                <div className="flex  space-x-2 ">
                  <div className="w-52 ">
                    <div className="relative searchin">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                        Mobile No
                      </label>
                      <input
                        type="search"
                        id="default-search"
                        className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                        placeholder="Mobile..."
                        required
                        value={request.mobile}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          setRequest((prevState) => {
                            return { ...prevState, mobile: newValue };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="w-52 ">
                    <div className="flex-col slc_dvd topslt">
                      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">User Types</label>
                      <div className="relative searchin">
                        {appUsers && appUsers.length > 0 && (
                          <SelectComponent
                            className="capitalize"
                            //title={"User Types"}
                            selected={userTypesArray}
                            setSelected={setUserTypesArray}
                            dataArr={appUsers}
                          />
                        )}</div>
                    </div>
                  </div>

                  <div className="">
                    <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      &nbsp;
                    </label>

                    <div className="flex flex-row  gap-2 ">
                      <div className="relative searchin">
                        {
                          JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.sudama && (
                            <button
                              className="btn btn-outline-success clear-both float-right pdbtn_all whitespace-nowrap"
                              onClick={() => setPointTransferModal(true)}
                            >
                              Order Transfer Detailed
                            </button>
                          )
                        }
                      </div>
                      <div className="relative searchin">
                        <button
                          className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                          onClick={() => {
                            fetchAppUserByUserTypeFunction(request);
                            // fetchAppUserByUserTypeCsvFunction();
                          }}
                        >
                          Search
                        </button>
                      </div>
                      <div className="relative searchin">
                        <button
                          className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                          onClick={() => {
                            clearFilters();
                          }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3">
                <DataTableComponent
                  keyField={(row) => row.SNo}
                  columns={columns}
                  data={allUsers.length && allUsers}
                  totalRows={usersCount}
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  paginationDefaultPage={currentPage}
                  paginationResetDefaultPage={paginationResetToggle}
                ></DataTableComponent>
              </div>
            </div>
          </div>
        </div>

        {showModal1 && (
          <ModalComponent
            size={"xl"}
            data={"nadnandand"}
            show={showModal1}
            setShow={setShowModal1}
          >
            <div className="w-full p-4">
              <div className="w-full m-auto  justify-center ">
                <div className="flex gap-1 ">
                  <div className="pb-1  bottom-2 w-full mb-2">
                    <InputComponent
                      name={"Remarks"}
                      type={"text"}
                      value={remarks}
                      setValue={setRemarks}
                      required={true}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center mt-3">
                <button
                  className="text-white bg-blue-700 hover-bg-blue-800 focus-ring-4 focus-outline-none focus-ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  onClick={() => {
                    setShowModal1(false);
                  }}
                >
                  Add
                </button>
              </div>
            </div>
          </ModalComponent>
        )}

        {pointTransferModal && (
          <ModalComponent show={pointTransferModal} setShow={setPointTransferModal} size="md">
            <div className="w-full p-4">
              <h2 className="text-lg font-bold mb-4 border-b pb-2">Order Transfer Detailed</h2>
              <div className="mb-4 flex items-center">
                <input
                  type="checkbox"
                  id="lifetime-checkbox-pt"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 shadow-sm"
                  checked={ptIsLifetime}
                  onChange={(e) => setPtIsLifetime(e.target.checked)}
                />
                <label htmlFor="lifetime-checkbox-pt" className="ml-2 text-sm font-medium text-gray-900">
                  Lifetime (Full History)
                </label>
              </div>
              
              {!ptIsLifetime && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                    <input
                      type="date"
                      className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={ptStartDate}
                      onChange={(e) => setPtStartDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                    <input
                      type="date"
                      className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={ptEndDate}
                      onChange={(e) => setPtEndDate(e.target.value)}
                    />
                  </div>
                </div>
              )}
              
              <div className="flex justify-center mt-4">
                <button
                  type="button"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  onClick={handlePointTransfer}
                  disabled={pointTransferLoading}
                >
                  {pointTransferLoading ? "Processing..." : "Submit"}
                </button>
              </div>
            </div>
          </ModalComponent>
        )}

      </div>
    </>
  );
};

export default OrderSummary;
